export default "__VITE_ASSET__C32nZy7k__"